import { createGlobalStyle } from 'styled-components';
import { withTheme } from '../se/theme';

export default createGlobalStyle`  
  html, body {
    background-color: ${withTheme(theme => theme.backgroundColor.string())};
  }
`;
